<template>
    <div v-if="error" class="text-danger small">
        {{ error }}
    </div>
</template>

<script>
export default {
    name: "ErrorLine",
    props: ['field'],

    computed: {
        error(){
            return this.$page.props?.errors[ this.field ] ?? '';
        }
    }

}
</script>

<style scoped>

</style>
